<template>
    <form class="file-uploader">
        <div v-if="enablePreview && file" class="preview">
            <a v-if="file?.url" :href="uploads.url( file?.url )" target="_blank">
                <img class="image" v-if="absolute_preview_url" :src="absolute_preview_url" alt="">
                <div class="name" v-if="file_name">{{ file_name }}</div>
            </a>
            <div class="actions" v-if="has_actions">
                <a v-if="isRemovable"
                   class="remove"
                   href="#"
                   @click.stop.prevent="remove()">&times;</a>
            </div>
        </div>
        <label v-if="!is_busy" class="upload"
             :class="{dropping}"
             @drop.prevent.stop="drop"
             @dragenter.prevent="dropping = true"
             @dragover.prevent="dropping = true"
             @dragleave.prevent="dropping = false">
            Drag & drop files here or click this area to upload.
            <input type="file" class="d-none" @change="filesChanged">
        </label>
        <div v-else class="show-progress">
            <progress-bar v-bind="progress"/>
        </div>
    </form>
</template>

<script>
import API from "@/API";
import uploads from "@/mixins/uploads";
import ProgressBar from "@/Components/Common/ProgressBar";

export default {
    name: "FileUploader",
    components: {ProgressBar},
    mixins: [uploads],

    props: {
        modelValue: Object,
        storagePath: String,
        enablePreview: {
            type: Boolean,
            default: true,
        },
        isRemovable: {
            type: Boolean,
            default: true,
        },
    },

    emits: ['change'],

    data(){
        return {
            is_busy: false,
            dropping: false,
            file: null,
            progress: {
                value: 0,
                intermediate: false,
            },
        };
    },


    computed: {
        file_name(){
            if( this.file ){
                if( this.file?.name ){
                    return this.file?.name;
                }if( this.file?.url ){
                    return this.file.url.split(/(\\|\/)/g).pop();
                }else{
                    return 'unknown';
                }
            }
            return '';
        },

        has_actions(){
            return this.isRemovable;
        },

        absolute_preview_url(){
            if( this.is_previewable ){
                return this.uploads.image(this.uploads.url( this.preview_url ), 300);
            }
            return this.icon_url;
        },

        is_previewable(){
            return this.is_image || this.is_pdf || this.is_video || this.is_pdf;
        },

        is_image(){
            return [
                'image/png',
                'image/jpg',
                'image/jpeg',
                'image/gif',
                'image/svg+xml',
                'image/tiff',
            ].indexOf(this.file.mime) >= 0;
        },

        is_pdf(){
            return [
                'application/pdf',
            ].indexOf(this.file.mime) >= 0;
        },

        is_document(){
            return [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/rtf',
            ].indexOf(this.file.mime) >= 0;
        },

        is_video(){
            return [
                'video/webm',
                'video/3gpp',
                'video/3gpp2',
                'video/avi',
                'video/mp4',
                'video/x-msvideo',
                'video/mpeg',
                'video/ogg',
            ].indexOf(this.file.mime) >= 0;
        },

        is_audio(){
            return [
                'audio/aac',
                'audio/midi',
                'audio/x-midi',
                'audio/mpeg',
                'audio/m4a',
                'audio/x-m4a',
                'audio/ogg',
                'audio/wav',
                'audio/webm',
                'audio/3gpp',
                'audio/3gpp2',
            ].indexOf(this.file.mime) >= 0;
        },

        preview_url(){

            if( this.is_previewable ){
                if( this.file?.preview_url ) return this.file?.preview_url;
                if( this.file?.url ) return this.file?.url;
            }
            return this.icon_url;
        },

        icon_url(){
            if ( this.is_audio ) return '/images/file-icons/audio-file.png';
            if ( this.is_video ) return '/images/file-icons/video-file.png';
            if ( this.is_pdf ) return '/images/file-icons/pdf-file.png';
            if ( this.is_document ) return '/images/file-icons/document-file.png';
            return '/images/file-icons/file.png';
        }

    },


    watch: {
        modelValue(value){
            this.file = value;
        }
    },

    methods: {
        drop(ev){
            this.upload( ev.dataTransfer?.files );
        },

        filesChanged(ev){
            this.upload( ev.target?.files );
        },

        setValue(value){
            this.file = value;
            this.$emit('update:modelValue', value);
            this.$emit('change', value);
        },

        async upload(files){

            if( this.is_busy ) return;

            this.progress.value = 0;
            this.progress.intermediate = true;
            this.is_busy = true;

            if( files && files.length ){
                const upload = await API.uploads.store( files[0], this.storagePath, {
                    onUploadProgress: (progress) => {
                        // this.progress.intermediate = false;
                        this.progress.value = Math.ceil((progress.loaded * 100) / progress.total);

                        if( this.progress >= 99 ){
                            this.progress.value = 100;
                            this.progress.intermediate = true;
                        }

                        return this.progress.value;
                    }
                });
                if( upload.file ){
                    this.setValue( upload.file );
                }
            }else{
                console.log({error: files});
            }

            this.progress.value = 100;
            this.progress.intermediate = false;
            this.is_busy = false;

        },


        remove(){
            if( !confirm('Are you sure to remove this?') ) return;
            this.setValue(null);
        }

    },


    beforeMount() {
        // console.log({model: this.modelValue});
        this.file = this.modelValue;
    }

}
</script>

<style lang="scss" scoped>
// .file-uploader{

// }

.preview{
    position: relative;
    max-width: 240px;

    .image{
        display: block;
        max-width: 100%;
        margin-bottom: 1rem;
    }
    .name{
        margin-bottom: 1rem;
    }
}


.actions{
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.3rem;
    display: flex;

    > * {
        display: block;
        padding: 0.1rem 0.5rem;
        margin-left: 0.3rem;
        text-decoration: none;
        min-width: 2rem;
        text-align: center;
        font-size: 1.2rem;

        &:first-child{
            margin-left: auto;
        }
    }

    .remove{
        background: $danger;
        color: white;
        border-radius: 0.3rem;
    }
}

.upload{
    display: block;
    border: rgba(black, 0.2) solid 2px;
    padding: 2rem;
    color: rgba( black, 0.4 );
    background: rgba(black, 0.06);
    cursor: pointer;
    user-select: none;
    border-radius: 0.6rem;

    &.dropping, &:hover{
        background: rgba(black, 0.2);
    }
}


//.progress{
//    display: block;
//    border: rgba(black, 0.2) solid 2px;
//    padding: 2rem;
//    color: rgba( black, 0.4 );
//    background: rgba(black, 0.06);
//}


</style>
